module.exports = __webpack_public_path__ + "static/pseudodragon-308958d8430f09bd92db2b20d1004223.jpeg";